import { useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, X, ArrowUpRight } from "lucide-react";
import { useLang } from "../lib/i18n";
import { getSeason, SEASON_COPY, GLOW_PATH } from "../lib/season";

const KEY = "gioia_season_banner_closed";

export const SeasonBanner = () => {
  const { lang } = useLang();
  const season = getSeason();
  const [closed, setClosed] = useState(() => sessionStorage.getItem(KEY) === season);
  if (!season || closed) return null;
  const c = SEASON_COPY[season][lang] ?? SEASON_COPY[season].it;
  const close = () => { sessionStorage.setItem(KEY, season); setClosed(true); };
  return (
    <div data-testid="season-banner" className="relative bg-[#C9A66B] text-[#14110F]">
      <div className="max-w-[1440px] mx-auto pl-4 pr-10 sm:px-12 min-h-10 py-2 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-center text-[0.78rem] sm:text-[0.82rem]">
        <span className="inline-flex items-center gap-1.5 font-serif-d italic text-base leading-none">
          <Sparkles className="w-3.5 h-3.5" strokeWidth={1.5} /> {c.tag}
        </span>
        <span className="hidden md:inline font-light">{c.text}</span>
        <span className="flex items-center gap-4">
          <Link to={GLOW_PATH} data-testid="season-banner-glow-link" className="group inline-flex items-center gap-1 tracking-[0.16em] uppercase text-[0.68rem] font-medium underline underline-offset-4 hover:text-[#F6F2EC] transition-colors duration-300">
            {c.cta} <ArrowUpRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:rotate-45" />
          </Link>
          <Link to="/#gift" data-testid="season-banner-gift-link" className="tracking-[0.16em] uppercase text-[0.68rem] font-medium underline underline-offset-4 hover:text-[#F6F2EC] transition-colors duration-300">
            {c.gifts}
          </Link>
        </span>
      </div>
      <button type="button" onClick={close} aria-label="Chiudi" data-testid="season-banner-close" className="absolute right-3 top-1/2 -translate-y-1/2 p-1 hover:text-[#F6F2EC] transition-colors duration-300">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
